// removed by extract-text-webpack-plugin
module.exports = {"m-orderForm":"aaOcygVx5Ng-KO_aSB_zH","m-orderForm__headings":"_3p5WeM4OsERigPUgg2y7bd","a-orderForm__heading":"_1NnZALZ429F2DblkP1HOQw","a-orderForm__heading--color":"_3nKmQZg0-soe-4lvtsuiT6","a-orderForm__heading--product":"_2ya7z2efLK1z39EAtd1w-P","a-orderForm__heading--quantity":"_2wdSQR5j4xMuPakWLqvnMP","a-orderForm__heading--price":"_3P6nzJvbP4vIoIoJj9MaAg","orderTotals":"_1CP9R33ZZ08jy2BTHTad45","m-orderForm--actions-top":"CnXlnM3CUDzJJ67hNIkoa","formActions":"gXAiawZGuJUCLxooOAgpQ"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/CartForm/flourishStyle.scss
// module id = 928
// module chunks = 0